.root {
  flex: 1;
  display: flex;
  max-height: 100%;
  overflow: hidden;
  justify-content: space-between;
}

.buttonColumn {
  display: flex;
  flex-direction: column;
}

.transferButton {
  margin: 4px 0;
}

.dndList {
  min-width: 200px;
}
